import { Named } from './named';
import { IViolation } from './annotation';

type NamedValidator = (named: Named) => IViolation[];

export class NamedCompositeValidator {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    public static CreateValidator(validators: NamedValidator[]): NamedValidator {
        return (named: Named): IViolation[] => {
            const errorList: IViolation[] = [];
            if (validators && validators.length > 0) {
                for (const validator of validators) {
                    const errors = validator(named);

                    if (errors && errors.length > 0) {
                        errorList.push(...errors);
                    }
                }
            }
            return errorList;
        };
    }
}
